import { clsx } from "clsx";
import type { ClassValue } from "clsx";
import { toast } from "sonner";
import { twMerge } from "tailwind-merge";

export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));

export const capitalize = (str: string) =>
	str.charAt(0).toUpperCase() + str.slice(1);

/**
 * Formats an estimated impact / AEO lift percentage value for display.
 * Keeps up to 2 decimals without rounding to an integer, and strips trailing
 * zeros: 3.10 -> "3.1", 3.00 -> "3", 3.45 -> "3.45".
 * Returns only the numeric part (callers append their own "%" / " %").
 */
export const formatImpactPercentage = (value: number): string =>
	`${Number(value.toFixed(2))}`;

export const handleError = (error: unknown): void => {
	toast.error(error as string);
};
